export default __webpack_public_path__ + "static/media/microFinanceBankingImg.28a95617.png";